import { render, staticRenderFns } from "./LiveClassScheduleInfoInfo.vue?vue&type=template&id=3d0ab9b4&scoped=true&"
import script from "./LiveClassScheduleInfoInfo.vue?vue&type=script&lang=js&"
export * from "./LiveClassScheduleInfoInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0ab9b4",
  null
  
)

export default component.exports